import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function AuroraCardSection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 bg-gradient-to-br from-purple-900 via-gray-900 to-blue-900 overflow-hidden">
      {/* Background Card Image */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/90 via-gray-900/85 to-blue-900/90"></div>
        <img 
          src="https://static.readdy.ai/image/75eaeb23002452c01ddd137892cf07ae/319b7508bf20d2d7b051b337d1bbc2ef.png"
          alt="Aurora Card"
          className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-auto object-contain opacity-30 mix-blend-lighten"
          style={{ filter: 'blur(1px)' }}
        />
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20 z-0">
        <div className="absolute top-20 left-10 w-72 h-72 bg-purple-500 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            {t('aurora.hero.title')}
          </h2>
          <p className="text-2xl text-purple-200 font-semibold mb-6">
            {t('aurora.hero.subtitle')}
          </p>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto mb-10 leading-relaxed">
            {t('aurora.hero.description')}
          </p>
          <Link to="/aurora-card" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <Button className="bg-purple-600 hover:bg-purple-700 text-white px-8 py-4 rounded-lg font-semibold text-lg transition-all shadow-lg hover:shadow-xl whitespace-nowrap">
              <i className="ri-bank-card-line mr-2"></i>
              {t('aurora.hero.title')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
